/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

import { cn } from "lib/utils/shadcn";

export interface IProgress {
  value: number;
  size: "sm" | "lg" | "xl";
  progressClass?: string;
  bgClass?: string;
}

const sizes = {
  sm: "h-0.5",
  lg: "h-[3px]",
  xl: "h-[4px]",
};

const Progress = ({
  value = 0,
  size = "lg",
  progressClass,
  bgClass,
}: IProgress) => {
  return (
    <div
      className={cn(
        "w-full bg-[#535353] rounded-full overflow-hidden",
        size && sizes[size],
        bgClass,
      )}
      test-id="nAQTxtrB"
    >
      <div
        className={cn(" bg-[#BABABA]", progressClass, size && sizes[size])}
        style={{ width: `${value}%` }}
        test-id="VZ4j7Tm6"
      ></div>
    </div>
  );
};

export default Progress;
